import gql from "graphql-tag";

// Bulk insert of one row rather than `insert_..._one`: the user role can insert but not select this
// table, and Hasura only generates the `_one` field (which returns the row) for roles that can read it.

// Append-only: one row per welcome-tour lifecycle moment (opened/completed/abandoned/replayed).
// Never updated, never read back by the app — see welcomeFlowShared.ts's recordWelcomeFlowEvent.
// userId/tenantId are stamped by Hasura presets, never sent from the client.
const InsertUserWelcomeFlowEventMutation = gql`
  mutation InsertUserWelcomeFlowEvent($flowKey: String!, $event: String!, $variant: String, $stepIndex: Int, $stepKey: String) {
    insert_userWelcomeFlowEvent(
      objects: [{ flowKey: $flowKey, event: $event, variant: $variant, stepIndex: $stepIndex, stepKey: $stepKey }]
    ) {
      affected_rows
    }
  }
`;

export default InsertUserWelcomeFlowEventMutation;
